import { render } from "./MobileWalletBtn.vue?vue&type=template&id=fe7ca0e4&scoped=true&ts=true"
import script from "./MobileWalletBtn.vue?vue&type=script&lang=ts"
export * from "./MobileWalletBtn.vue?vue&type=script&lang=ts"

import "./MobileWalletBtn.vue?vue&type=style&index=0&id=fe7ca0e4&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe7ca0e4"]])

export default __exports__